"use strict";

import './notice';

App.Pages.Notices.Service = class Service extends App.Pages.Notices.Notice
	{

	get template()
		{
		//language=HTML
		return `
			<div class="card-content card-content-padding">
				{{body}}
			</div>
			<div class="card-footer">
				<div class="date">{{dt}}</div>
			</div>

		`;
		}

	onRender(event)
		{
		super.onRender(event);
		this.dom = Platform.loadTemplate(this.template, this.dom, 'content');

		this.noticeData.body = this.body;
		this.noticeData.dt = Util.dtFormat(this.noticeData.dt);

		MK.parseBindings(this.noticeData, this.dom.content);

		this.dom.card.append(this.dom.content);
		}

	get body()
		{
		return this.noticeData.data.text;
		}


	};